import NewCreditCard from './NewCreditCard';
import SavedCreditCard from './SavedCreditCard';
import CreditCard from './CreditCard';

export default CreditCard;

export {
  NewCreditCard,
  SavedCreditCard,
};
